module.exports = __webpack_public_path__ + "fonts/Allegro-2.cf068f19.otf";